<template>
  <div class="emat-checkbox" @click="changeValue()" :class="{'is-disabled': disabled}">
    <div class="item">
      <span class="label" v-text="label"></span>
    </div>
    <div class="checkbox" :class="{'hoverable': !disabled}">
      <span class="check-mark" :class="{'active': value}">
        <img src="https://generator.elektramat.nl/images/Check.svg" class="icon">
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxInput',
  props: {
    /**
     * Unique name for your input
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * The current selected value (Boolean) True or false
     */
    value: {
      type: [Boolean, Number],
      required: true,
      default: false,
    },
    /**
     * A label for the input
     */
    label: {
      type: String,
      required: true,
      default: null,
    },
    /**
     * An extra label for the input (sub-label gray text)
     */
    extraLabel: {
      type: String,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeValue() {
      if (this.disabled) {
        return;
      }

      let oldValue = this.value;
      /**
       * Output the input for v-model
       */
      this.$emit('input', this.value ? 0 : 1);

      /**
       * Output the change with the new and old values
       */
      this.$emit('change', this.value ? 0 : 1, oldValue);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";

.emat-checkbox {
  font-family: var(--font);
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  .item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .label {
    display: block;
    font-size: 14px;
    color: #4D4F5C;
    line-height: 16px;
  }

  .extra-label {
    font-size: 10px;
    font-family: var(--font);
    color: rgba(0,0,0,.3);
    font-weight: 700;
    display: block;
  }

  &.is-disabled {
    cursor: initial;
  }
}

.checkbox {
  margin-left: auto;
  position: relative;
  width: 20px;
  height: 20px;
  border: 1px solid var(--c-primary);
  border-radius: 4px;
  background-color: #ffffff;
  transition: background-color .2s ease-in;

  &.hoverable:hover {
    background-color: var(--c-primary-light);
    cursor: pointer;

    .check-mark > .icon {
      opacity: 1;
    }
  }

  .check-mark {
    display: flex;
    align-content: center;
    align-items: center;
    position: absolute;
    top: 25%;
    left: 25%;
    width: 50%;
    height: 50%;
    border-radius: 4px;
    transition: all .3s;

    .icon {
      margin: 0 auto;
      width: 15px;
      opacity: 0;
      transition: all .2s ease-in;
    }

    &.active {
      background-color: var(--c-primary);
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 0;

      .icon {
        opacity: 1;
      }
    }
  }
}
</style>
